import { createRoot } from 'react-dom/client';
import App from './app/app';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createTheme } from '@mui/material/styles';

const container = document.getElementById('root');
const root = createRoot(container);

// Unique identifier to check if the app is already open in another tab
const uniqueIdentifier = Math.random().toString(36).substring(7);

const originalTitle = document.title;
let isModalDisplayed = false;

// Create a broadcast channel with a unique name
const broadcastChannel = new BroadcastChannel('unique_tab_channel');

const originalFavicon = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/website/android-chrome-512x512.png`;
const resetFavicon = () => {
    const faviconLink = document.querySelector('link[rel="icon"]');
    console.log(faviconLink.href)
    faviconLink.href = originalFavicon;
};

// Listen for messages from other tabs
broadcastChannel.addEventListener('message', (event) => {
    if (event.data.action === 'check_duplicate') {
        if (event.data.uniqueIdentifier === uniqueIdentifier) {
            // This tab is the original tab
            console.log('This is the original tab');
        } else {
            if (!isModalDisplayed) {
                // If another tab is already open
                isModalDisplayed = true;

                document.title = 'AIVAGAM (Notification)';

                // const faviconLink = document.querySelector('link[rel="icon"]');
                // const originalFaviconHref = faviconLink.href;
                // faviconLink.href = 'https://cdn-icons-png.flaticon.com/512/9503/9503179.png';

                const overlay = document.createElement('div');
                overlay.style.position = 'fixed';
                overlay.style.top = '0';
                overlay.style.left = '0';
                overlay.style.width = '100%';
                overlay.style.height = '100%';
                overlay.style.background = 'rgba(0, 0, 0, 1)';
                overlay.style.zIndex = '9999';
                overlay.style.display = 'flex';
                overlay.style.justifyContent = 'center';
                overlay.style.alignItems = 'center';
                document.body.appendChild(overlay);

                const modal = document.createElement('div');
                modal.style.background = 'white';
                modal.style.padding = '20px';
                modal.style.borderRadius = '8px';
                modal.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.1)';
                modal.style.textAlign = 'center';
                overlay.appendChild(modal);

                const title = document.createElement('h2');
                title.style.fontSize = '24px';
                title.style.marginBottom = '10px';
                title.textContent = 'Alert!';
                modal.appendChild(title);

                const message = document.createElement('p');
                message.style.fontSize = '16px';
                message.style.marginBottom = '20px';
                message.textContent = 'AIVAGAM is already open in another window! Click on "Use Here" to continue in the current window';
                modal.appendChild(message);

                const buttonContainer = document.createElement('div');
                buttonContainer.style.display = 'flex';
                buttonContainer.style.justifyContent = 'space-evenly';
                modal.appendChild(buttonContainer);

                const cancelButton = document.createElement('button');
                cancelButton.style.background = '#ff1616';
                cancelButton.style.color = 'white';
                cancelButton.style.border = 'none';
                cancelButton.style.padding = '10px 20px';
                cancelButton.style.borderRadius = '4px';
                cancelButton.style.cursor = 'pointer';
                // cancelButton.style.margin = '4px';
                cancelButton.style.transition = 'background 0.3s ease';
                cancelButton.textContent = 'Close';
                buttonContainer.appendChild(cancelButton);

                const useHereButton = document.createElement('button');
                useHereButton.style.background = '#1450a0';
                useHereButton.style.color = 'white';
                useHereButton.style.border = 'none';
                useHereButton.style.padding = '10px 20px';
                useHereButton.style.borderRadius = '4px';
                useHereButton.style.cursor = 'pointer';
                // cancelButton.style.margin = '4px';
                useHereButton.style.transition = 'background 0.3s ease';
                useHereButton.textContent = 'Use Here';
                buttonContainer.appendChild(useHereButton);

                useHereButton.addEventListener('click', () => {
                    isModalDisplayed = false;
                    broadcastChannel.postMessage({
                        action: 'check_duplicate',
                        uniqueIdentifier: uniqueIdentifier,
                    });
                    overlay.remove(); // Close the modal
                    document.title = originalTitle;
                    resetFavicon();
                    window.location.reload()
                });

                // Navigate to topgrep.com on clicking close
                cancelButton.addEventListener('click', () => {
                    isModalDisplayed = false;
                    window.location.href = 'https://aivagam.topgrep.com/';
                });
            }
        }
    }
});

// Send a message to other tabs to check for duplicates
broadcastChannel.postMessage({
    action: 'check_duplicate',
    uniqueIdentifier: uniqueIdentifier,
});

// root.render(<App />);

const theme = createTheme({
    palette: {
        primary: {
            main: '#1450a0',
            light: '#165bb6',
            dark: '#10407f',
            contrastText: '#ffffff',
        },
        success: {
            main: '#008037'
        }
    },
});

root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
    </ThemeProvider>
);

const welcome = 'Welcome to AIVAGAM 🤖';
console.log(welcome);
